import React from "react";
import {
  Box,
  Container,
  Typography,
  List,
  ListItem,
  Divider,
  styled,
} from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import reinforcementImg from "../../images/reinforcement/construction.png";

const ImageWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "200px",
  borderRadius: theme.spacing(2),
  overflow: "hidden",
  marginBottom: theme.spacing(3),
}));

const StyledImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

const StatItem = styled(ListItem)(({ theme }) => ({
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

const StatLabel = styled(Typography)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  color: "black",
  marginBottom: theme.spacing(0.5),
  fontWeight: 500,
}));

const StatValue = styled(Typography)(({ theme }) => ({
  color: "#0c4d96",
  lineHeight: 1.5,
}));

const CompanyInfoComponent = ({ textOnLeft = false }) => {
  const { t } = useTranslation();
  const jccInfo = t("reinforcementDetails.jccInfo", { returnObjects: true });

  return (
    <Container
      maxWidth="sm"
      sx={{
        py: 3,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {/* Image Section */}
        <ImageWrapper
          component={motion.div}
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <StyledImage src={reinforcementImg} alt="Company Image" />
        </ImageWrapper>

        {/* Title Section */}
        <Box sx={{ mb: 2 }}>
          <Typography
            fontSize={"1rem"}
            fontWeight={650}
            color={"black"}
            textAlign={"center"}
            variant="h6"
          >
            {`${jccInfo.title} ${jccInfo.description}`}{" "}
          </Typography>
        </Box>

        {/* Statistics Section */}
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <List disablePadding>
            {jccInfo.statistics.map((statistic, index) => (
              <React.Fragment key={index}>
                <StatItem
                  component={motion.div}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <StatLabel variant="subtitle2">
                    {statistic.key}
                    <i
                      className={`fa-solid ${statistic.icon}`}
                      style={{ fontSize: "1rem" }}
                    />
                  </StatLabel>
                  <StatValue variant="body2">
                    {statistic.key === "Link:" ||
                    statistic.key === "リンク：" ? (
                      <a
                        href={statistic.value}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "inherit",
                          textDecoration: "none",
                        }}
                      >
                        {statistic.value}
                      </a>
                    ) : (
                      <>
                        {statistic.value1}
                        {statistic.value2 && (
                          <>
                            <br />
                            {statistic.value2}
                          </>
                        )}
                      </>
                    )}
                  </StatValue>
                </StatItem>
                {index < jccInfo.statistics.length - 1 && (
                  <Divider sx={{ mx: 2 }} />
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </motion.div>
    </Container>
  );
};

export default CompanyInfoComponent;
